<template>
    <div v-if="ready">
        <MenuOctolo logo="/static/img/habitat/LOGO-OCTOLO-HABITAT-NEW.svg">
            <menu-home />
        </MenuOctolo>
        <Slide1 />
        <Slide2 />
        <Slide3 />
        <Slide5 />
        <Slide6 />
        <Slide7 />
        <Slide4 />
        <Slide9 />
        <Slide8 />
        <FooterComponent habitat/>
    </div>
</template>

<script>
import MenuOctolo from '@/toremove/components/menu/Menu.vue';
import MenuHome   from '@/pages/habitat/Menu.vue';
import Slide1     from '@/pages/habitat/slideHabitat/Slide1.vue';
import Slide2     from '@/pages/habitat/slideHabitat/Slide2.vue';
import Slide3     from '@/pages/habitat/slideHabitat/Slide3.vue';
import Slide4     from '@/pages/habitat/slideHabitat/Slide4.vue';
import Slide5     from '@/pages/habitat/slideHabitat/Slide5.vue';
import Slide6     from '@/pages/habitat/slideHabitat/Slide6.vue';
import Slide7     from '@/pages/habitat/slideHabitat/Slide7.vue';
import Slide8     from '@/pages/habitat/slideHabitat/Slide8.vue';
import FooterComponent     from '@/toremove/components/octolo/utils/Footer.vue';

export default {
    name: 'Habitat',
    components: {
        MenuOctolo,
        MenuHome,
        Slide1,
        Slide2,
        Slide3,
        Slide4,
        Slide5,
        Slide6,
        Slide7,
        Slide8,
        FooterComponent,
    },
    async mounted(){
        await this.loadTranslate();
        await this.loadConfig();
        if ((import.meta.env.PROD) || (process.env.ENABLE_SENTRY)) {
            this.$sentry.getCurrentScope().addEventProcessor(event => {
                event.release = this.$store.getters['User/getRelease'];
                return event;
            });
        }
        this.ready = true;
    },
}
</script>

<style lang="scss">
@import "@/assets/octolo.scss";
</style>
